export enum TenantStatus {
  LIVE = "Live",
  OBSOLETE = "Obsolete",
  IMPLEMENTATION = "Implementation"
}

export const tenantStatuses = Object.values<string>(TenantStatus);


export enum TenantOrigin {
  EXTERNAL = 'external'
}

export const tenantOrigin = Object.values(TenantOrigin);